import './App.css';
import Chat from './Chat';
import Sidebar from './Sidebar';
import SignIn from './SignIn';
import {useAuthState} from 'react-firebase-hooks/auth'
import { auth } from './firebase';


function App() {

  const [user] = useAuthState(auth)
  
  return (
    <>
    <div className="App">
      
      
      
      {user ? <div className="app__body"><Chat/></div> : <SignIn/>}
        
        
      <p className="developer">
            Developed by <b>Madhubabu Akkishetty</b>
         </p>


 
      
    </div>
    </>
  );
}

export default App;
